module.exports = __webpack_public_path__ + "static/media/7_of_spades.52127792.png";